export default class AlterarSenha{
    senha = "";
    novaSenha = "";
    confirmacaoNovaSenha = "";
}



// WEBPACK FOOTER //
// ./src/model/AlterarSenha.js